import React from 'react';
import {
  Box, Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Button, Chip,
} from '@mui/material';
import Add from '@mui/icons-material/Add';

export default function Invoices() {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" fontWeight="bold">Facturas</Typography>
        <Button variant="contained" startIcon={<Add />}>Nueva Factura</Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>N. Factura</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Proyecto</TableCell>
              <TableCell>Descripcion</TableCell>
              <TableCell align="right">Base</TableCell>
              <TableCell align="right">IVA</TableCell>
              <TableCell align="right">Total</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Vencimiento</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={9} align="center">
                <Typography color="textSecondary">No hay facturas registradas</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
